export default ({ i18n }, inject) => {
  inject('localizeFallbackPath', text => i18n.t(text))
}
